import { QueryPermission } from '@auth/permissionsEnum'
import { generatePathWithParams } from '@common/utils/urlUtils'
import { RouteKeyEnum, ROUTES } from 'src/routes'

export const createQCTabItems = (studyId: string, qcTaskId: string) => [
  {
    route: {
      path: generatePathWithParams(ROUTES.QC_TASK_OVERVIEW.path, { studyId, qcTaskId }),
      label: 'Overview',
      routeKey: RouteKeyEnum.QC_TASK_OVERVIEW,
    },
  },
  {
    route: {
      path: generatePathWithParams(ROUTES.QC_TASK_QUERIES.path, { studyId, qcTaskId }),
      label: 'Queries',
      routeKey: RouteKeyEnum.QC_TASK_QUERIES,
    },
    permissions: [QueryPermission.ALL, QueryPermission.LIST_ALL],
  },
]
